import { atom } from 'recoil';

/** 안 읽은 알림 수 — 헤더 종 배지·MY 탭 점에 공유. 로그인 상태에서 주기적으로 갱신된다. */
export const unreadNotificationCountAtom = atom<number>({
    key: 'unreadNotificationCount',
    default: 0,
});
